import classnames from 'classnames';

import type { Breadcrumb } from '@cobliteam/common-types';

interface BreadcrumbItemProps<T> {
  breadcrumb: Breadcrumb<T>;
  selectedBreadcrumb: Breadcrumb<T>;
  disabled?: boolean;
  onBreadcrumbClick?: (breadcrumb: Breadcrumb<T>) => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const BreadcrumbItem = <T extends string>({ breadcrumb, selectedBreadcrumb, disabled, onBreadcrumbClick }: BreadcrumbItemProps<T>) => {
  const handleBreadcrumbClick = () => {
    if (selectedBreadcrumb !== breadcrumb && !disabled && onBreadcrumbClick) {
      onBreadcrumbClick(breadcrumb);
    }
  };

  return (
    <a
      className={classnames({
        selected: selectedBreadcrumb.id === breadcrumb.id,
        disabled,
      })}
      onClick={handleBreadcrumbClick}
    >
      {breadcrumb.icon && breadcrumb.icon}
      {breadcrumb.title}
    </a>
  );
};
